import React from 'react';
import ReactDOM from 'react-dom';
import { AppEducation } from './pages/AppEducation';
import 'animate.css'

ReactDOM.render(
   <AppEducation />,
  document.getElementById('root')
);
